import { FeeHurdleBasis } from '../investment';

export * as Api from './api';

export enum FeeChargeType {
  Investor = 'investor',
  Investment = 'investment',
}

export enum FeeExportType {
  General = 'GENERAL',
  Custodian = 'CUSTODIAN',
}

export enum FeeExistenceFilterType {
  All = 'ALL',
  Future = 'FUTURE',
  Past = 'PAST',
}

export type PerformanceFeeDefinition = {
  feePercentageIncVAT: number;
  hurdle: number;
  hurdleBasis: FeeHurdleBasis;
  maxHurdle?: number;
  includeFeesInHurdle: boolean;
  excludeResidualCapitalFromHurdle?: boolean;
};
